export default __webpack_public_path__ + "images/C3.03c6d59.png";